import { useQuery } from "@apollo/client/react";

import { Maybe } from "types/generated";

import { GET_AZURE_DEVOPS_INTEGRATION } from "./gql";

const useGetAzureDevOpsIntegration = (id: Maybe<string>) => {
  const { data, loading, error } = useQuery(GET_AZURE_DEVOPS_INTEGRATION, {
    variables: {
      id,
    },
    fetchPolicy: "no-cache",
  });

  return {
    integration: data?.azureDevOpsRepoIntegration,
    isPageLoading: loading && !data?.azureDevOpsRepoIntegration,
    error,
  };
};

export default useGetAzureDevOpsIntegration;
